import { render } from "./NotReceivedBox.vue?vue&type=template&id=04b5f1b2"
import script from "./NotReceivedBox.vue?vue&type=script&lang=js"
export * from "./NotReceivedBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__